export enum LogoutPositionEnum {
  Center = 'logout-center',
  Right = 'logout-right'
}
